import { get, post, put, del, postBlob } from "@/utils/api";

export const VendorAPI = {
    query: async (params) => {
        return await get("/vendor", params);
    },
    actives: async (params) => {
        return await get("/vendor/actives");
    },
    get: async (id) => {
        return await get(`/vendor/${id}`);
    },
    add: async (params) => {
        return await put("/vendor", params);
    },
    update: async (id, params) => {
        return await post(`/vendor/${id}`, params);
    },
    enable: async (id) => {
        return await post(`/vendor/${id}/1`);
    },
    disable: async (id) => {
        return await post(`/vendor/${id}/2`);
    },
    getDocuments: async (id) => {
        return await get("/vendor/document", { vendorId: id });
    },
    addDocument: async (id, file) => {
        return await post(`/vendor/document?vendorId=${id}`, { file: file });
    },
    updateDocument: async (id, params) => {
        return await post(`/vendor/document/${id}`, params);
    },
    deleteDocument: async (id) => {
        return await del(`/vendor/document/${id}`);
    }
};

export const POAPI = {
    query: async (params) => {
        return await get("/po", params)
    },
    report: async (params) => {
        return await get("/po/report", params)
    },
    export: async (params) => {
        return await postBlob("/po/export", params);
    },
    queryByItemId: async (page, itemId) => {
        const criteria = { page: page };
        return await get(`/po/item/${itemId}`, criteria)
    },
    get: async (id) => {
        return await get(`/po/${id}`);
    },
    add: async (values) => {
        return await put("/po", values);
    },
    update: async (id, values) => {
        return await post(`/po/${id}`, values);
    },
    updateStatus: async (id, status) => {
        return await post(`/po/${id}/status/${status}`);
    },
    print: async (poId) => {
        return await postBlob(`/po/${poId}/print`);
    },
    getEmail: async (poId) => {
        return await post(`/po/${poId}/email/content`);
    },
    sendEmail: async (poId, params) => {
        return await post(`/po/${poId}/email/send`, params);
    },
    getNotBilled: async () => {
        return await get(`/po/not-billed`);
    },
    getVendorLastItem: async (vendorId, itemId) => {
        if (!vendorId || !itemId) return null;
        return await get(`/po/vendor/${vendorId}/item/${itemId}/last`);
    },
    updateNote: async (id, note) => {
        return await post(`/po/${id}/note`, { note });
    }
}

export const ItemReceiptAPI = {
    query: async (page, params) => {
        return await get("/receipt", { page: page, ...params });
    },
    add: async (params) => {
        return await put("/receipt", params);
    },
    get: async (id) => {
        return await get(`/receipt/${id}`);
    },
    delete: async (id) => {
        return await del(`/receipt/${id}`);
    },
    update: async (id, params) => {
        return await post(`/receipt/${id}`, params);
    },
    item: async (receiptItemId) => {
        return await get(`/receipt/item/${receiptItemId}`);
    },
    received: async (poId) => {
        return await get("/receipt/received", { poId: poId });
    },
    notBilled: async () => {
        return await get("/receipt/not-billed");
    },
    print: async (receiptId) => {
        return await postBlob(`/receipt/${receiptId}/print`);
    },
    getEmail: async (receiptId) => {
        return await post(`/receipt/${receiptId}/email/content`);
    },
    sendEmail: async (receiptId, params) => {
        return await post(`/receipt/${receiptId}/email/send`, params);
    },
    checkInventoryInUse: async (id) => {
        return await get(`/receipt/${id}/inventory-in-use`);
    }
}

export const BillAPI = {
    query: async (params) => {
        return await get("/bill", { ...params });
    },
    actives: async (params) => {
        return await get("/bill/active", params);
    },
    add: async (params) => {
        return await put("/bill", params);
    },
    update: async (id, params) => {
        return await post(`/bill/${id}`, params);
    },
    get: async (id) => {
        return await get(`/bill/${id}`);
    },
    delete: async (id) => {
        return await del(`/bill/${id}`);
    },
    payments: async (billId) => {
        return await get(`/bill/${billId}/payments`);
    },
    print: async (billId) => {
        return await postBlob(`/bill/${billId}/print`);
    },
    getEmail: async (billId) => {
        return await post(`/bill/${billId}/email/content`);
    },
    sendEmail: async (billId, params) => {
        return await post(`/bill/${billId}/email/send`, params);
    },
    getVendorLastItem: async (vendorId, itemId) => {
        if (!vendorId || !itemId) return null;
        return await get(`/bill/vendor/${vendorId}/item/${itemId}/last`);
    },
    getTotalBalance: async (params) => {
        return await get("/bill/total-balance", params);
    },
    getPastDueBalance: async (params) => {
        return await get("/bill/past-due-balance", params);
    },
    exportExcel: async (params) => {
        return await postBlob("/bill/export", params);
    },
    openVendors: async () => {
        return await get("/bill/open-vendors");
    }
}
